export default "__VITE_PUBLIC_ASSET__dc768337__"